import { post, postQuery } from "../http"

/**
 * 公式查询接口
 */
export default {
    // 获取图形验证码
    getCaptcha(captchaId) {
        return process.env.VUE_APP_API_URL + `/api/code/captcha.jpg?captchaId=${captchaId}`
    },
    // 查询前置鉴权接口
    beforeQueryAuth(data) {
        return post('/api/publicNotice/encryptParams', data)
    },
    // 证书公示数据查询
    queryPublicData(data, headers) {
        return postQuery('/api/publicNotice/static/nonEncrypt/query', data,  { ...headers })
    }
}